var drawer = function () {
  Element.prototype.closest ||
    (Element.prototype.matches ||
      (Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector),
    (Element.prototype.closest = function (t) {
      var s = this,
        e = this;
      if (!document.documentElement.contains(s)) return null;
      do {
        if (e.matches(t)) return e;
        e = e.parentElement;
      } while (e !== null);
      return null;
    }));
  var r = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: "is-active",
      visibleClass: "is-visible",
      selectorTarget: "[data-drawer-target]",
      selectorTrigger: "[data-drawer-trigger]",
      selectorClose: "[data-drawer-close]",
    },
    a = function (t) {
      t.getAttribute("aria-expanded") === "true"
        ? t.setAttribute("aria-expanded", !1)
        : t.setAttribute("aria-expanded", !0);
    },
    n = function (t) {
      var s = document.getElementById(t.getAttribute("aria-controls"));
      s.classList.add(r.activeClass),
        (document.documentElement.style.overflow = "hidden"),
        a(t),
        setTimeout(function () {
          s.classList.add(r.visibleClass);
        }, r.speedOpen);
    },
    o = function (t) {
      var s = t.closest(r.selectorTarget),
        e = document.querySelector('[aria-controls="' + s.id + '"');
      s.classList.remove(r.visibleClass),
        (document.documentElement.style.overflow = ""),
        a(e),
        setTimeout(function () {
          s.classList.remove(r.activeClass);
        }, r.speedClose);
    },
    c = function (t) {
      var s = t.target,
        e = s.closest(r.selectorTrigger),
        l = s.closest(r.selectorClose);
      e && n(e), l && o(l), (e || l) && t.preventDefault();
    },
    i = function (t) {
      if (t.key === "Escape" || t.keyCode === 27) {
        var s = document.querySelectorAll(r.selectorTarget),
          e;
        for (e = 0; e < s.length; ++e)
          s[e].classList.contains(r.activeClass) && o(s[e]);
      }
    };
  document.addEventListener("click", c, !1),
    document.addEventListener("keydown", i, !1);
};
drawer();
//# sourceMappingURL=/s/files/1/0665/4957/9992/t/8/assets/drawer.js.map?v=1676722937
